const indexItems = [
  {
    title: '暗网是什么',
    desc: '从零入门暗网基础概念，了解表层网、深网与暗网的区别，掌握暗网基本运作原理。',
    icon: 'ri-question-mark',
    color: 'primary',
  },
  {
    title: '暗网怎么进入',
    desc: '详细教程手把手教你安全进入暗网，包括环境准备、网络配置与关键注意事项。',
    icon: 'ri-login-box-line',
    color: 'accent',
  },
  {
    title: '暗网浏览器推荐',
    desc: 'Tor浏览器、I2P、Freenet等暗网浏览器横向对比评测，帮你挑选最适合的工具。',
    icon: 'ri-global-line',
    color: 'secondary',
  },
  {
    title: 'Tor浏览器下载',
    desc: '提供Tor浏览器最新版本下载指引与安装配置教程，适配Windows/macOS/Linux/Android。',
    icon: 'ri-download-2-line',
    color: 'primary',
  },
  {
    title: '暗网网址导航',
    desc: '收录暗网常用网址与深度网资源索引，分类整理搜索引擎、论坛、市场与信息站点。',
    icon: 'ri-compass-3-line',
    color: 'accent',
  },
  {
    title: '暗网安全访问',
    desc: '暗网安全访问全攻略：VPN搭配、匿名环境搭建、隐私保护、诈骗识别与风险规避。',
    icon: 'ri-shield-check-line',
    color: 'secondary',
  },
  {
    title: '吃瓜爆料聚合',
    desc: '匿名投稿与全网吃瓜内容聚合，第一时间获取暗网相关话题的最新动态与讨论。',
    icon: 'ri-fire-line',
    color: 'primary',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          暗网指南索引
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          七大核心板块覆盖暗网入门到精通全路径，按需探索安全知识
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href={`#${item.color === 'accent' ? 'cards' : item.color === 'secondary' ? 'features' : 'carousel'}`}
              className="group bg-background-100 border border-background-200/60 hover:border-background-300 rounded-lg p-5 transition-all duration-200"
            >
              <div
                className={`w-10 h-10 rounded-md flex items-center justify-center mb-4 ${
                  item.color === 'primary'
                    ? 'bg-primary-500/10 text-primary-400'
                    : item.color === 'accent'
                    ? 'bg-accent-500/10 text-accent-400'
                    : 'bg-secondary-500/10 text-secondary-400'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors duration-200">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-xs leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}